import { render, staticRenderFns } from "./StatementsJoint.vue?vue&type=template&id=763d731e&scoped=true&"
import script from "./StatementsJoint.vue?vue&type=script&lang=js&"
export * from "./StatementsJoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763d731e",
  null
  
)

export default component.exports